import { createFileRoute } from '@tanstack/react-router';
import { Check } from '@phosphor-icons/react';
import { Icon } from '../../../../../../components/Icon';
import { SettingCard } from '../../../../../../components/settings/setting-card';
import { ROLE_COLUMNS, ROLE_MATRIX, type RoleAccess } from '../../../../../../lib/roles-matrix';

export const Route = createFileRoute('/subdomain/admin/_staff/settings/workspace/roles')({
  component: RolesPage,
});

function Cell({ access, label }: { access: RoleAccess; label: string }) {
  if (access === true) {
    return (
      <span className="flex text-feedback-success">
        <Icon icon={Check} size="md" />
        <span className="sr-only">{label}: allowed</span>
      </span>
    );
  }
  if (access === false) {
    return (
      <span className="text-text-muted">
        —<span className="sr-only">{label}: not allowed</span>
      </span>
    );
  }
  return <span className="text-body-small text-text-secondary">{access}</span>;
}

/** Read-only reference: roles are fixed, so there is nothing to edit here (Figma A16.9). */
function RolesPage() {
  return (
    <SettingCard
      title="What each role can do"
      subtitle="Roles are fixed. To change what someone can do, change their role in Staff."
    >
      <div className="overflow-x-auto">
        <table className="w-full min-w-(--mbm-layout-dialog-wide-width) border-collapse text-left">
          <thead>
            <tr className="text-label-small text-text-section uppercase">
              <td className="py-(--mbm-space-3)" />
              {ROLE_COLUMNS.map((c) => (
                <th key={c.role} scope="col" className="py-(--mbm-space-3) pr-(--mbm-space-3) font-semibold">
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROLE_MATRIX.map((row) => (
              <tr key={row.capability} className="border-t border-border-line">
                <th
                  scope="row"
                  className="py-(--mbm-space-3) pr-(--mbm-space-4) text-left text-label-medium font-semibold text-text-primary"
                >
                  {row.capability}
                </th>
                {ROLE_COLUMNS.map((c) => (
                  <td key={c.role} className="py-(--mbm-space-3) pr-(--mbm-space-3)">
                    <Cell access={row.access[c.role]} label={`${row.capability}, ${c.label}`} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SettingCard>
  );
}
